import React from 'react';
import ExerciseInterface from './ExerciseSystem/ExerciseInterface';
import { M06_TOPICS, M06_MODULE_INFO } from '../data/mathExercises/M06_Transformations';

// Create minimal problems data for M06
const M06_SAMPLE_PROBLEMS = [
  {
    id: 'M06_01_P001',
    topicId: 'M06_01',
    question: "將點 A(2, 3) 向右平移 4 個單位，向上平移 2 個單位後的坐標是？",
    solution: "(6, 5)",
    explanation: "平移變換：(x, y) → (x + h, y + k)，其中 h = 4, k = 2",
    difficulty: 1,
    order: 1,
    steps: ["原坐標：(2, 3)", "向右平移4單位：x + 4", "向上平移2單位：y + 2", "新坐標：(2+4, 3+2) = (6, 5)"]
  },
  {
    id: 'M06_02_P001',
    topicId: 'M06_02',
    question: "點 B(3, -2) 關於 x 軸的反射點坐標是？",
    solution: "(3, 2)",
    explanation: "關於 x 軸反射：(x, y) → (x, -y)",
    difficulty: 1,
    order: 1,
    steps: ["關於x軸反射", "x坐標不變", "y坐標變號", "結果：(3, 2)"]
  }
];

const M06TransformationsExercise = ({ onProgress }) => {
  const topics = M06_TOPICS;
  const problems = M06_SAMPLE_PROBLEMS;
  const moduleInfo = M06_MODULE_INFO;

  return (
    <ExerciseInterface
      moduleInfo={moduleInfo}
      topics={topics}
      problems={problems}
      onProgress={onProgress}
      className="m06-exercise"
    />
  );
};

export default M06TransformationsExercise; 